import { ReactNode, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import classnames from 'classnames';

import useRouterHelper from 'hooks/useRouterHelper';
import ThemeCheckBox from 'components/Input/CheckBox/ThemeCheckBox';
import { IFilterItem } from 'utils/IFilterItem';

import { IGradesQueryInterface } from '../GradesQueryInterface';

import './FilterItem.scoped.scss';

interface Props {
  name: string;
  disablePopover?: boolean;
  leftIcon?: ReactNode;
  values: Array<IFilterItem>;
}

const FilterItem: React.FC<Props> = ({
  name,
  disablePopover: disabled = false,
  leftIcon: icon = null,
  values,
}) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const { query, routePush } = useRouterHelper<IGradesQueryInterface>();

  const key = _.capitalize(name.replace('grades:', ''));

  function checked(id) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const object = { ...query } as {};
    if (!object[key]) {
      object[`${key}`] = id;
    } else {
      const items = (object[key] as string).split(',');
      if (items.indexOf(id) > -1) {
        items.splice(items.indexOf(id), 1);
      } else {
        items.push(id);
      }

      object[key] = items.join(',');
    }

    routePush({
      search: {
        ...object,
      },
    });
  }

  return (
    <div
      ref={ref}
      tabIndex={0}
      className={classnames({
        'grades-filter-item': true,
        disabled,

        'with-icon': icon !== null,
      })}
    >
      <div>
        <h5 className="filter-name">
          {icon && <span>{icon}</span>}
          <span>{t(name)}</span>
        </h5>

        {!disabled && (
          <p className="filter-selected-items">
            {query[key] ? (query[key] as string).split(',').length : '0'} {t('grades:Selected')}
          </p>
        )}
      </div>

      <div className="content">
        {values.map(obj => {
          return (
            <div key={obj.title + obj.id}>
              <ThemeCheckBox
                label={obj.title}
                checked={query[key] && (query[key] as string).split(',').indexOf(obj.id) > -1}
                onChange={() => {
                  checked(obj.id);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FilterItem;
